<div class="row spacing-20">
  <!-- Total Summary Card -->
  <div class="col-12">
    <div class="card mb-5">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h4 class="fw-bold mb-1">{{ 'manageEvent.expenses.totalEventExpenses' | translate }}</h4>
            <p class="text-muted mb-0">
              {{ filteredExpenses.length }} {{ 'manageEvent.expenses.expensesRecorded' | translate }}
              @if (hasFilter) {
                <span class="text-primary">({{ 'manageEvent.expenses.filtered' | translate }})</span>
              }
            </p>
          </div>
          <div class="text-end">
            <h2 class="fw-bold text-primary mb-0">{{ formatCurrency(getTotalExpenses()) }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Expenses List -->
  <div class="col-12">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
        <h4 class="mb-0">{{ 'manageEvent.expenses.title' | translate }}</h4>
        <div class="d-flex align-items-center gap-3">
          <!-- Filter by User -->
          @if (expenses.length > 0) {
            <select
              class="form-select"
              style="width: 200px;"
              [ngModel]="selectedUserId"
              (ngModelChange)="onUserFilterChange($event)"
            >
              <option [ngValue]="null">{{ 'manageEvent.expenses.allUsers' | translate }}</option>
              @for (user of uniqueUsers; track user.user_id) {
                <option [ngValue]="user.user_id">{{ user.full_name }}</option>
              }
            </select>
            <app-button
              [variant]="'outline'"
              [label]="'manageEvent.expenses.exportPdf' | translate"
              [iconClass]="'fa fa-file-pdf'"
              (clicked)="exportToPDF()"
            />
          }
          <app-button
            [variant]="'primary'"
            [label]="'manageEvent.expenses.addExpense' | translate"
            [iconClass]="'fa fa-plus'"
            (clicked)="openAddModal()"
          />
        </div>
      </div>
      <div class="card-body">
        @if (loading) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
            <p>{{ 'manageEvent.expenses.loading' | translate }}</p>
          </div>
        } @else if (expenses.length === 0) {
          <div class="text-center py-10">
            <i class="fa fa-receipt fs-3x text-muted mb-5"></i>
            <h4 class="text-muted">{{ 'manageEvent.expenses.noExpenses' | translate }}</h4>
            <p class="text-muted">{{ 'manageEvent.expenses.noExpensesHint' | translate }}</p>
            <app-button
              [variant]="'primary'"
              [label]="'manageEvent.expenses.addFirstExpense' | translate"
              [iconClass]="'fa fa-plus'"
              (clicked)="openAddModal()"
            />
          </div>
        } @else if (filteredExpenses.length === 0) {
          <div class="text-center py-10">
            <i class="fa fa-filter fs-3x text-muted mb-5"></i>
            <h4 class="text-muted">{{ 'manageEvent.expenses.noMatchFilter' | translate }}</h4>
            <p class="text-muted">{{ 'manageEvent.expenses.noMatchFilterHint' | translate }}</p>
            <app-button
              [variant]="'outline'"
              [label]="'manageEvent.expenses.clearFilter' | translate"
              [iconClass]="'fa fa-times'"
              (clicked)="clearFilter()"
            />
          </div>
        } @else {
          <div class="table-responsive">
            <table class="table table-row-bordered table-hover align-middle">
              <thead>
                <tr class="fw-bold text-muted">
                  <th>{{ 'manageEvent.expenses.tableTitle' | translate }}</th>
                  <th>{{ 'manageEvent.expenses.tableDescription' | translate }}</th>
                  <th>{{ 'manageEvent.expenses.tableAddedBy' | translate }}</th>
                  <th>{{ 'manageEvent.expenses.tableDate' | translate }}</th>
                  <th class="text-end">{{ 'manageEvent.expenses.tableAmount' | translate }}</th>
                  <th class="text-end">{{ 'manageEvent.expenses.tableReceipts' | translate }}</th>
                  <th class="text-end">{{ 'manageEvent.expenses.tableActions' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (expense of filteredExpenses; track expense.expense_id) {
                  <tr>
                    <td>
                      <span class="fw-bold">{{ expense.title }}</span>
                    </td>
                    <td>
                      <span class="text-muted">{{ expense.description || '-' }}</span>
                    </td>
                    <td>
                      @if (expense.user) {
                        <div class="d-flex align-items-center">
                          @if (expense.user.profile_image_url) {
                            <img [src]="expense.user.profile_image_url" class="rounded-circle me-2" style="width: 32px; height: 32px; object-fit: cover;" />
                          } @else {
                            <div class="rounded-circle bg-primary d-flex align-items-center justify-content-center me-2" style="width: 32px; height: 32px;">
                              <span class="text-white fw-bold" style="font-size: 0.75rem;">
                                {{ expense.user.first_name?.charAt(0) }}{{ expense.user.last_name?.charAt(0) }}
                              </span>
                            </div>
                          }
                          <span>{{ expense.user.full_name }}</span>
                        </div>
                      } @else {
                        <span class="text-muted">-</span>
                      }
                    </td>
                    <td>
                      <span class="text-muted">{{ formatDate(expense.created_at) }}</span>
                    </td>
                    <td class="text-end">
                      <span class="fw-bold">{{ formatCurrency(expense.amount, expense.currency) }}</span>
                    </td>
                    <td class="text-end">
                      @if (expense.images && expense.images.length > 0) {
                        <span
                          class="badge badge-light-primary receipt-badge"
                          (click)="openReceiptsLightbox(expense.images)"
                        >
                          <i class="fa fa-image me-1"></i>{{ expense.images.length }}
                        </span>
                      } @else {
                        <span class="text-muted">-</span>
                      }
                    </td>
                    <td class="text-end">
                      <div class="d-flex justify-content-end gap-2">
                        <app-button
                          [variant]="'ghost'"
                          [iconClass]="'fa fa-pencil'"
                          [size]="'sm'"
                          (clicked)="openEditModal(expense)"
                        />
                        <app-button
                          [variant]="'ghost'"
                          [iconClass]="'fa fa-trash text-danger'"
                          [size]="'sm'"
                          (clicked)="deleteExpense(expense)"
                        />
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <tr class="fw-bold bg-light">
                  <td colspan="4">{{ 'manageEvent.expenses.total' | translate }}</td>
                  <td class="text-end">{{ formatCurrency(getTotalExpenses()) }}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- Lightbox -->
@if (lightboxImages.length > 0) {
  <div class="lightbox-overlay" (click)="closeLightbox()">
    <button type="button" class="lightbox-close" (click)="closeLightbox()">
      <i class="fa fa-times"></i>
    </button>

    @if (lightboxImages.length > 1) {
      <button
        type="button"
        class="lightbox-nav lightbox-prev"
        [disabled]="lightboxIndex === 0"
        (click)="prevImage(); $event.stopPropagation()"
      >
        <i class="fa fa-chevron-left"></i>
      </button>
    }

    @if (lightboxImages[lightboxIndex]?.image_url) {
      <img
        [src]="lightboxImages[lightboxIndex].image_url"
        class="lightbox-image"
        (click)="$event.stopPropagation()"
      />
    }

    @if (lightboxImages.length > 1) {
      <button
        type="button"
        class="lightbox-nav lightbox-next"
        [disabled]="lightboxIndex === lightboxImages.length - 1"
        (click)="nextImage(); $event.stopPropagation()"
      >
        <i class="fa fa-chevron-right"></i>
      </button>

      <div class="lightbox-counter" (click)="$event.stopPropagation()">
        {{ lightboxIndex + 1 }} / {{ lightboxImages.length }}
      </div>
    }
  </div>
}
